<ion-content class="ion-no-padding">
  <button type="button" class="cnt-modal-close" aria-label="Close" (click)="closeModal()">&times;</button>
  <div class="image-container">
    <div class="image-wrapper">
      <img
        alt="currentPhoto?.caption"
        *ngIf="currentPhoto"
        [src]="getLargePhotoUrl(currentPhoto)"
        (load)="loaded = true"
      />
    </div>
    <curbnturf-spinner [show]="loaded !== true"> </curbnturf-spinner>
  </div>
</ion-content>
